import React from 'react';
import env from 'env';
import { Table } from 'components/table/table';
import { useGet } from 'components';
import utils from 'utils';
import { SiteLink } from 'components';
import { Loading, ErrorPopup } from 'components';

/** ProductType.Dartfish value — filter list to Dartfish products only. */
const DARTFISH_PRODUCT_TYPE = 5;

export function DartfishList(props) {
  const columns = React.useMemo(
    () => [
      {
        Header: 'Product Name',
        accessor: 'productName',
        Cell: (c) => (
          <SiteLink to={`/admin/product/${c.row.original.productId}`}>
            <b>{c.cell.value}</b>
          </SiteLink>
        )
      },
      {
        Header: 'Status',
        accessor: 'productStatusText'
      },
      {
        Header: 'Url',
        accessor: 'productSlug'
      },
      {
        Header: 'Price',
        accessor: 'price'
      },
      {
        Header: 'Updated Date',
        accessor: 'dateUpdated',
        Cell: (c) => c.cell.value && utils.date.formatYYYYMMDD(c.cell.value)
      }
    ],
    []
  );

  const get = useGet();

  React.useEffect(() => {
    const url = `${env.apiBase}/api/productAdmin/getList?productType=${DARTFISH_PRODUCT_TYPE}`;
    get.send(url);
    // eslint-disable-next-line
  }, []);

  if (get.loading()) {
    return <Loading />;
  }
  if (get.hasErrors()) {
    return <ErrorPopup title="Loading Error" errors={get.errors} />;
  }

  const data = get.response || [];
  return (
    <>
      <h1>Dartfish Products</h1>
      <p className="text-muted">Dartfish products only. Edit opens the full product form with Dartfish fields.</p>
      <div className="filter" style={{ minHeight: '30px' }}>
        <SiteLink className="btn btn-outline-primary" to="/admin/product/new?type=dartfish">
          Add Dartfish product
        </SiteLink>
      </div>
      <Table columns={columns} data={data} />
    </>
  );
}
